import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HomeownerAuthContext = createContext(null);

export function HomeownerAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const check = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/homeowner/me`, { withCredentials: true });
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const signup = useCallback(async ({ email, password, name }) => {
    const { data } = await axios.post(
      `${API}/homeowner/signup`, { email, password, name },
      { withCredentials: true }
    );
    setUser(data);
    return data;
  }, []);

  const login = useCallback(async ({ email, password }) => {
    const { data } = await axios.post(
      `${API}/homeowner/login`, { email, password },
      { withCredentials: true }
    );
    setUser(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    try { await axios.post(`${API}/homeowner/logout`, {}, { withCredentials: true }); } catch {}
    setUser(null);
  }, []);

  const updateProfile = useCallback(async (payload) => {
    const { data } = await axios.patch(
      `${API}/homeowner/me`, payload,
      { withCredentials: true }
    );
    setUser(data);
    return data;
  }, []);

  return (
    <HomeownerAuthContext.Provider value={{ user, loading, signup, login, logout, check, updateProfile }}>
      {children}
    </HomeownerAuthContext.Provider>
  );
}

export function useHomeownerAuth() {
  const ctx = useContext(HomeownerAuthContext);
  if (!ctx) throw new Error("useHomeownerAuth must be inside HomeownerAuthProvider");
  return ctx;
}
